// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Category-AssignToIngredientModal-Search-__style___1j7nx","right":"app-pages-Ingredient-Category-AssignToIngredientModal-Search-__style___1b4kJ"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Category/AssignToIngredientModal/Search/style.css
// module id = 2349
// module chunks = 0